import React from 'react';
import { v4 as uuid } from 'uuid';
import cleanObject from '../../../../utils/cleanObject';
import { GOODRX } from '../../../../constants';
export const renderMetaItemFromType = (item, contextData) => {
  var _contextData$page;

  const siteName = ((_contextData$page = contextData.page) === null || _contextData$page === void 0 ? void 0 : _contextData$page.siteName) || GOODRX;
  const componentMap = {
    description: () => [/*#__PURE__*/React.createElement("meta", {
      content: item.value || siteName,
      key: "description",
      name: "description"
    }), /*#__PURE__*/React.createElement("meta", {
      content: item.value || siteName,
      key: "og:description",
      property: "og:description"
    })],
    // eslint-disable-next-line @typescript-eslint/naming-convention
    medical_condition: () => [/*#__PURE__*/React.createElement("script", {
      key: uuid(),
      type: "application/ld+json"
    }, JSON.stringify(cleanObject([{
      key: 'associatedAnatomy.name',
      keyToRemove: 'associatedAnatomy'
    }, {
      key: 'alternateName',
      keyToRemove: 'alternateName'
    }], item.value)))],
    title: () => [/*#__PURE__*/React.createElement("title", {
      key: "title"
    }, item.value ? `${item.value}${item.suffix || ''}` : siteName), /*#__PURE__*/React.createElement("meta", {
      content: item.value ? `${item.value}${item.suffix || ''}` : siteName,
      key: "og:title",
      property: "og:title"
    })],
    twitter: () => [/*#__PURE__*/React.createElement("meta", {
      content: "summary",
      key: "twitter:card",
      property: "twitter:card"
    }), /*#__PURE__*/React.createElement("meta", {
      content: item.value,
      key: "twitter:site",
      property: "twitter:site"
    }), /*#__PURE__*/React.createElement("meta", {
      content: item.value,
      key: "twitter:creator",
      property: "twitter:creator"
    })]
  };
  return (componentMap[item === null || item === void 0 ? void 0 : item.type] || (() => []))();
};